import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ColumnsFilterComponent} from './columns-filter.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    ColumnsFilterComponent
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule
  ],
  exports: [
    ColumnsFilterComponent
  ]
})
export class ColumnsFilterModule { }
